import React from 'react';
import { string, func } from 'prop-types';
import styles from './PrettyIcon.scss';

export default function PrettyIcon(props) {
  const { className, onClick, children } = props;
  const dataHook = 'pretty-icon-' + props['data-hook'];

  return (
    <button className={`${styles.wrapper} ${className}`} onClick={onClick} data-hook={dataHook} type="button">
      <div className={styles.background} />
      <div className={styles.foreground}>{React.cloneElement(children, { size: 24 })}</div>
    </button>
  );
}

PrettyIcon.propTypes = {
  className: string,
  onClick: func,
  'data-hook': string,
};
